import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
export function taxResponseMapper(taxReportData) {
    const initial = {
        taxDetail: [],
    };
    let taxDetailsObj = { taxDetail: [] };
    if (taxReportData) {
        taxDetailsObj = taxReportData.taxDetail.reduce((acc, taxReportRecord) => {
            acc.taxDetail.push(Object.assign(Object.assign({}, taxReportRecord), { tradingGain: addDashIfNullOrUndefined(taxReportRecord.tradingGain), dividend: addDashIfNullOrUndefined(taxReportRecord.dividend), interest: addDashIfNullOrUndefined(taxReportRecord.interest) }));
            return acc;
        }, initial);
    }
    else {
        taxDetailsObj = initial;
    }
    return {
        taxSummary: taxReportData ? taxReportData.taxSummary : null,
        taxDetail: taxDetailsObj.taxDetail,
        taxDataFlags: {
            isBodEnabled: taxReportData === null || taxReportData === void 0 ? void 0 : taxReportData.isBodEnabled,
            bodProcessInfoMessage: taxReportData === null || taxReportData === void 0 ? void 0 : taxReportData.bodProcessInfoMessage
        },
    };
}
